import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

export const VehicleAPI = (baseURL: string, clientId: string) => {
    const api = AxiosAPI({
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    });

    const getVehicles = () => {
        const serviceUrl = 'peipvehicle-api/Vehicle/GetVehicles';
            return api.get(serviceUrl)
                .then((response: any) => response?.data)
                .catch((error: any) => Promise.reject(error));
    };

    return {
        getVehicles
    };
};
